/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.familias': 'Familias',
  'familias.agregarFamilias': 'Crear Familias',
  'familias.modificarFamilias': 'Editar Familias',
  'familias.familiaId': 'Familia Id',
  'familias.empresaId': 'Empresa Id',
  'familias.familiaDescripcion': 'Familia Descripción',
  'familias.VerFamilias': 'Ver Familias',
};
